import React, { useState, Fragment } from "react";
import { useDispatch } from "react-redux";

import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import pageTitle from "../../utils/pageTitle";
import { ADM_AREAS_DETAILS_URL } from "../../config";

import DetailPanel from "../../components/adm-areas/DetailPanel";
import MediaPanel from "../../components/adm-areas/MediaPanel";
import CorrectionPanel from "../../components/adm-areas/CorrectionPanel";
import MapPanel from "../../components/adm-areas/MapPanel";
import SubAreaPanel from "../../components/adm-areas/SubAreaPanel";
import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";

import CountrySelector from "../../components/adm-areas/CountrySelector";

import makeApiRequest from "../../utils/axios/new-axios";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    padding: "10px",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
}));

export default function AdmAreas() {
  pageTitle("Administrative Areas");
  const dispatch = useDispatch();

  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [admDetails, setAdmDetails] = useState(null);
  const [hasChild, setHasChild] = useState(0);
  const [mapDetails, setMapdetails] = useState(null);
  const classes = useStyles();

  function handleChange(e, value) {
    if (value) {
      fetchAdmDetails(value.admId);
    }
  }

  async function fetchAdmDetails(admId) {
    try {
      setIsLoadingDetails(true);
      setAdmDetails(null);
      const response = await makeApiRequest({
        url: `${ADM_AREAS_DETAILS_URL.url}/${admId}`,
        method: ADM_AREAS_DETAILS_URL.method,
      });
      setAdmDetails(response.data);
      setHasChild(response.data.hasChild);
      setMapdetails({
        coordinates: response.data.coordinates,
        infoWindowTitle: response.data.name,
        infoWindowDetail: response.data.googlePlaceId,
      });
      setIsLoadingDetails(false);
    } catch (error) {
      setIsLoadingDetails(false);
      dispatch(
        showErrorAlert(
          "Adm Details Fetch Error : " +
          (!!error.response
            ? `${error.response.status}! - ${error.response.data.errorMessage}`
            : error.message)
        )
      );
    }
  }

  return (
    <Fragment>
      <Container style={{ padding: "10px" }}>
        <h3>Admin Areas</h3>
        <Paper className={classes.paper}>
          <CountrySelector onChange={handleChange} style={{ width: 300 }} />
        </Paper>
      </Container>
      <Container style={{ marginTop: "20px", padding: "10px" }}>
        <ComponentLoader isLoading={isLoadingDetails} />
        {!isLoadingDetails && admDetails && (
          <Fragment>
            <DetailPanel
              level={1}
              admDetails={admDetails}
              setHasChild={setHasChild}
              setMapdetails={setMapdetails}
            />
            <MediaPanel parentId={admDetails.admId} medias={admDetails.media} />
            <CorrectionPanel
              parentId={admDetails.admId}
              corrections={admDetails.correction}
            />
            <MapPanel mapDetails={mapDetails} />
            {hasChild === 1 && (
              <SubAreaPanel
                level={1}
                parentId={admDetails.admId}
                countryCode={admDetails.countryCode}
                hasChild={hasChild}
                admType={admDetails.type}
              />
            )}
          </Fragment>
        )}
      </Container>
    </Fragment>
  );
}
